import React, { useCallback, useMemo } from 'react'

import MultipleDv360MediaUpload from './MultipleDv360MediaUpload'
import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import ImageSupportedFormatsAndSizes from './ImageSupportedFormatsAndSizes'
import VideoSupportedFormatsAndSizes from './VideoSupportedFormatsAndSizes'

import {
  dv360AdSizeValidationSchema,
  dv360VideoAdValidationSchema
} from '../../Routes/CreativeFileUploadRoute/validation'
import { VIDEO_DEFAULT } from '../../../../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'
import { MEDIA_ITEMS } from '../../Routes/CreativeFileUploadRoute/fields'

import useDrawerFormStyles from '../../../../../../../styles/common/drawerForms'

const stepFields = [MEDIA_ITEMS]

const FileUploadStep = ({ formik, handleStepChange, lineItemType }) => {
  const drawerFormClasses = useDrawerFormStyles()

  const { values } = formik

  const fileValidationSchema = useMemo(() => {
    if (lineItemType === VIDEO_DEFAULT) {
      return dv360VideoAdValidationSchema
    } else {
      return dv360AdSizeValidationSchema
    }
  }, [lineItemType])

  const uploadFilesTitle = useMemo(() => {
    return lineItemType === VIDEO_DEFAULT ? 'Selected videos:' : 'Selected images:'
  }, [lineItemType])

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields, values)
  }, [handleStepChange, values])

  return (
    <Step stepTitle="Upload ad creatives" handleContinue={handleContinue}>
      {lineItemType === VIDEO_DEFAULT ? <VideoSupportedFormatsAndSizes /> : <ImageSupportedFormatsAndSizes />}
      <section className={drawerFormClasses.section}>
        <h4 className={drawerFormClasses.sectionTitle}>{uploadFilesTitle}</h4>
        <MultipleDv360MediaUpload
          formik={formik}
          FileItemPath={MEDIA_ITEMS}
          fileValidationSchema={fileValidationSchema}
        />
      </section>
    </Step>
  )
}

export default FileUploadStep
